import { ReactNode, useEffect, useState } from 'react';
import { ControlLabelContainer } from './styles';
import { PitchPopup } from '../../../Toolbox/ControlPopup/PitchPopup';
import { SpeedPopup } from '../../../Toolbox/ControlPopup/SpeedPopup';
import { VolumePopup } from '../../../Toolbox/ControlPopup/VolumePopup';
import { StylePopup } from '../../../Toolbox/ControlPopup/StylePopup';
import { Pause } from '@phosphor-icons/react';
import { BreakPopup } from '../../../Toolbox/ControlPopup/BreakPopup';

interface ControlLabelProps {
  icon: ReactNode;
  blockId: string;
  control: string;
}

export const ControlLabel = ({ icon, blockId, control }: ControlLabelProps) => {
  const [controlPopup, setControlPopup] = useState<any>(null);

  useEffect(() => {
    if (control) {
      switch (control) {
        case 'speed':
          setControlPopup(<SpeedPopup blockId={blockId} />);
          break;
        case 'pitch':
          setControlPopup(<PitchPopup blockId={blockId} />);
          break;
        case 'volume':
          setControlPopup(<VolumePopup blockId={blockId} />);
          break;
        case 'style':
          setControlPopup(<StylePopup blockId={blockId} />);
          break;
        case 'pronunciation':
          break;
        case 'break':
          setControlPopup(<BreakPopup blockId={blockId} />);
          break;
        default:
          break;
      }
    }
  }, [blockId, control]);

  return (
    <ControlLabelContainer>
      {icon}
      <div className="controlTooltip">{controlPopup}</div>
    </ControlLabelContainer>
  );
};
